import React from 'react';
import ViewContext, { clientView } from 'Context/ViewContext';
import WillSection from '../Sections/Will';
import GeneralPowerOfAttorneySection from '../Sections/GeneralPowerOfAttorney';
import AdvancedHealthCareDirectiveSection from '../Sections/AdvancedHealthCareDirective';
import TrustSection from '../Sections/Trust';
import GiftsToFamilySection from '../Sections/GiftsToFamily';
import Navigator from '../UI/Navigator';

const EstatePlanning = () => (
  <ViewContext.Consumer>
    {view => (
      <Navigator>
        <WillSection />
        <GeneralPowerOfAttorneySection />
        <AdvancedHealthCareDirectiveSection />
        <TrustSection />
        {clientView === view ? (
          <GiftsToFamilySection isLastSection />
        ) : (
          <GiftsToFamilySection />
        )}
      </Navigator>
    )}
  </ViewContext.Consumer>
);

export default EstatePlanning;
